// RECUR-28096 — Financials ingestion loader. Both Audited and Provisional tabs poll aica for
// documents still being extracted (median 6-9 min) and show a note in place of
// "(No data available)" while any are in flight. See financialsIngestion/types.ts for the
// response shape and useFinancialsIngestionStatus.ts for the polling hook.

/** Matches the backend's `financials.ingestion.in-progress.timeout.minutes` cadence (aica bounds
 *  a row as terminal at 30 min); polling faster would not surface new information sooner. */
export const FINANCIALS_INGESTION_POLL_INTERVAL_MS = 30_000;

/** Byte-identical to aica's BablerConstant / UW's IngestionConstants doctype strings — never
 *  substring/case-insensitive matched (AP-1). */
export const FINANCIALS_FILE_TYPE = {
    AUDITED: 'Audited Financials',
    PROVISIONAL: 'Provisional Financials',
} as const;

/** Design D3 — exact copy, no duration tail, no ellipsis. */
export const INGESTION_NOTE_MESSAGE = 'Fetching data from file uploaded';

/** usePolling stops permanently on its first thrown error (commonUtil.ts), so
 *  useFinancialsIngestionStatus tolerates this many CONSECUTIVE failed polls before giving up. */
export const FINANCIALS_INGESTION_MAX_CONSECUTIVE_FAILURES = 3;
